var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.811523,
    y: 0.404297,
    width: 64.6328,
    height: 64.6328,
    rx: 32.3164,
    fill: "#532160"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7005 39.1215L50.0612 34.2678C50.5254 34.0099 50.7833 33.5458 50.7833 33.03V23.3226C50.7833 22.8069 50.5254 22.3427 50.0612 22.0848L41.7005 17.2311C41.2363 16.9733 40.7206 16.9733 40.2564 17.2311L31.8899 22.0848C31.4258 22.3427 31.1679 22.8069 31.1679 23.3226V40.6171L25.2827 44.0268L19.3975 40.6171V33.8552L25.2827 30.4456L29.1565 32.6633V28.119L26.0048 26.3139C25.7985 26.2108 25.5406 26.1076 25.2827 26.1076C25.0249 26.1076 24.767 26.1592 24.5607 26.3139L16.1942 31.1733C15.73 31.4312 15.4722 31.8954 15.4722 32.4111V42.1185C15.4722 42.6343 15.73 43.0984 16.1942 43.3563L24.555 48.21C25.0191 48.4679 25.5349 48.4679 25.999 48.21L34.3598 43.3563C34.8239 43.0984 35.0818 42.6343 35.0818 42.1185V24.824L35.185 24.7724L40.9727 21.4144L46.8579 24.824V31.5859L40.9727 34.9898L37.0989 32.7721V37.3164L40.2507 39.1215C40.7149 39.3794 41.2306 39.3794 41.7005 39.1215Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.fe60406f44ba5f6e66605ffbcd348025.svg";
export { ForwardRef as ReactComponent };